import { LeadSource } from '../../models/application.model';
import CreditApplicationFormV2 from '../credit-application-form-v2/credit-application-form-v2.container';

export default function CreditApplication({ leadSource }: { leadSource: LeadSource }) {
  return (
    <>
      <section id="banner">
        <div className="banner-overlay">
          <h1>Service Form</h1>
        </div>
      </section>
      <CreditApplicationFormV2 leadSource={leadSource} />
    </>
  );
}
